import { Hyperlink } from './Hyperlink'

export default Hyperlink
